import { render, staticRenderFns } from "./BlogPostsAuthor.vue?vue&type=template&id=7111e8b5&"
import script from "./BlogPostsAuthor.vue?vue&type=script&lang=js&"
export * from "./BlogPostsAuthor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports